import * as React from "react";
import Box from "@mui/material/Box";
import { Formik } from "formik";
import Styles from "./UpdateOrder.module.scss";
import { useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import { cancelOrder } from "../../redux/admin/actions/admin.actions";
import { cancelOrderSchema } from "../validation/Schema";
import { topics, delay } from "../../data";
import { SelectField } from "../Form/SelectField";

export default function CancelForm(props) {
  const dispatch = useDispatch();

  const agent = JSON.parse(localStorage.getItem("userDetails"));

  let agentId = agent.data.id;

  const [topic, setTopic] = React.useState();
  const [delaies, setDelay] = React.useState();

  React.useEffect(() => {
    let options = topics?.map((t) => ({
      label: t?.label,
      value: t?.value,
    }));
    setTopic(options);
  }, []);

  React.useEffect(() => {
    let options = delay?.map((t) => ({
      label: t?.label,
      value: t?.value,
    }));
    setDelay(options);
  }, []);

  return (
    <>
      <Formik
        initialValues={{
          title: props.title,
          reason: "",
          topic: "",
          delay: "",
          order_id: props.order_id,
          agent: agentId,
        }}
        validationSchema={cancelOrderSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          values.topic = values.topic.value;
          if (values.delay) {
            values.delay = values.delay.value;
          }
          dispatch(cancelOrder(values, { setSubmitting, resetForm }));
          props.onClickYes();
        }}
      >
        {({
          handleChange,
          handleSubmit,
          isSubmitting,
          values,
          event,
          resetForm,
          setFieldValue,
          handleBlur,
          errors,
          touched,
        }) => (
          <>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, minWidth: "50ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <>
                <div className="d-flex flex-column mb-3">
                  <p className={Styles.label}>Topic</p>

                  <div>
                    <SelectField
                      name="topic"
                      options={topic}
                      onChange={setFieldValue}
                      placeholder="Select topic"
                      onBlur={handleBlur}
                    />
                  </div>
                  {!values.topic && touched.topic ? (
                    <p className="text-danger mt-1 mx-2">
                      This field is required
                    </p>
                  ) : null}
                </div>

                {values.topic?.value === "Late Delivery" && (
                  <div className="d-flex flex-column mb-3">
                    <p className={Styles.label}>Delay</p>

                    <div>
                      <SelectField
                        name="delay"
                        options={delaies}
                        onChange={setFieldValue}
                        placeholder="Select delay"
                        onBlur={handleBlur}
                      />
                    </div>
                    {!values.delay && touched.delay ? (
                      <p className="text-danger mt-1 mx-2">
                        This field is required
                      </p>
                    ) : null}
                  </div>
                )}

                <p className={Styles.label}>Reason</p>
                <div>
                  <Form.Control
                    as="textarea"
                    onChange={handleChange}
                    name="reason"
                    placeholder="Reason"
                    style={{ height: "100px" }}
                  />
                </div>
                {errors.reason && touched.reason ? (
                  <p className="text-danger mt-1 mx-2">{errors.reason}</p>
                ) : null}
              </>

              <div className="d-flex justify-content-center mt-3">
                <button
                  type="submit"
                  className={` shadow-none ${Styles.actionBtn} ${Styles.confirm} `}
                  style={{ background: props.btnColor }}
                  onClick={() => props.onClickNo()}
                >
                  Exit
                </button>

                <button
                  type="submit"
                  className={` shadow-none  ${Styles.actionBtn} ${Styles.reject}`}
                  style={{ background: props.btnColor }}
                  onClick={handleSubmit}
                  disabled={!values.topic}
                >
                  Submit
                </button>
              </div>
            </Box>
          </>
        )}
      </Formik>
    </>
  );
}
